import CircleIcon from '@mui/icons-material/Circle';
import { Stack, Typography } from '@mui/material';
import React from 'react';
import theme from '../../../theme';

type EventTypeLabelProps = {
    type: string;
};

const getClassificationStyle = (type: string): { color: string; label: string } => {
    switch (type) {
        case 'COMPANY_UPDATE':
            return { color: theme.colors.warning['400'], label: 'Company update' };
        case 'NEW_FUND_OPPORTUNITY':
            return { color: '#12b981', label: 'New fund opportunity' };
        case 'SHARED_PIPELINE':
            return { color: theme.colors.violet['600'], label: 'Shared pipeline' };
        case 'NEW_DEAL':
        default:
            return { color: theme.colors.blue['600'], label: 'New deal' };
    }
};

const EventTypeLabel: React.FC<EventTypeLabelProps> = ({ type }) => {
    const { color, label } = getClassificationStyle(type);

    return (
        <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 1 }}>
            <CircleIcon sx={{ width: 12, height: 12, fill: color }} />
            <Typography sx={{
                fontFamily: 'Lato',
                fontSize: '0.85rem',
                fontWeight: 600,
                color: theme.colors.neutral['700'],
            }}>
                {label}
            </Typography>
        </Stack>
    );
};

export default EventTypeLabel;
